/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {AgentModel} from './models/AgentModel'
import {actions} from './redux/AgentsRedux'

type Props = {
  agent: AgentModel
  index: string
}

const AgentRow: FC<Props> = ({agent, index}) => {
  const dispatch = useDispatch()

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this agent?')) {
      dispatch(actions.deleteAgent(agent.id))
    }
  }

  return (
    <tr key={index}>
      <td>{agent.name}</td>
      <td>{agent.email}</td>
      <td>{new Date(agent.created_on * 1000).toLocaleString()}</td>
      <td className='text-end'>
        <button
          className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
          onClick={handleDelete}
        >
          <i className='bi bi-trash-fill fs-6'></i>
        </button>
      </td>
    </tr>
  )
}

export default AgentRow
